import { SRow } from '@avalara/skylab-sdk/react';
import { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { formatPrice, getSalestaxDefaultText } from '../../../shared/helpers';
import analytics from '../../lib/analytics';
import { costCalculator } from '../../lib/helpers';
import { selectState } from '../../selectors';
import { getRenewalDate } from '../helpers/buy-flow';
import { BlackText } from '../styled/components/thank-you';
import ThankYouBanner from './thank-you/banner';
import Resources from './thank-you/resources';

const Success = () => {
  const state = useSelector(selectState);
  const {
    avataxSignup: { buyComplete },
    buyFlow: { salestax },
    data: { abandonedSignupTracker },
  } = state;

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    window.removeEventListener('unload', abandonedSignupTracker || (() => undefined));
    analytics.page('SIGNUP_COMPLETE');
  }, []);

  const totalCost = costCalculator(state);

  return (
    <BlackText>
      <ThankYouBanner buyComplete={buyComplete} />
      <SRow className='justify-content-center'>
        <div>
          {buyComplete ? (
            <Fragment>
              <h3
                data-ref='buy.signup.success.direct-to-buy.content'
                id='direct-to-buy-success'
                className='success-title alt'
              >
                {totalCost !== 0 &&
                  `Your payment method has been charged ${formatPrice(totalCost)}${getSalestaxDefaultText(salestax)}`}
              </h3>
              <h3 data-ref='buy.signup.success.subscription-renewal-content' className='success-title alt'>
                {`Your subscription will automatically renew ${getRenewalDate(new Date())}`}
              </h3>
            </Fragment>
          ) : null}
          <Resources />
        </div>
      </SRow>
    </BlackText>
  );
};

export default Success;
